import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../shared/app.service';
import { of ,  from as fromPromise } from 'rxjs';
import { IPrikbordItemDb, defaultCacheTime} from '../shared/offline/cobradb';
import { state2 } from '../shared/state';

export interface IPrikbordItem extends IPrikbordItemDb {}
//   Id:number;
//   Soort:string;
//   Titel:string;
//   DatumUpdate:Date | string;
//   Url?:string;
//   Content?:string;
// }

@Injectable()
export class PrikbordService {


  constructor(private http:HttpClient,private appService:AppService) { }

  getPrikbordItems() {
 
    const url  = this.appService.getUrl('api/prikbord/GetPrikbordItems');
    //return this.http.post<IPrikbordItemDb[]>(url,{});
    // return fromPromise(cobraDb.retrieveTimeCached(cobraDb.prikborditems, cobraDb.prikborditems.toCollection(),
    //   this.http.post<IPrikbordItemDb[]>(url,{}),
    //   defaultCacheTime
    // ));
    return state2.getValueOrDefault('prikborddata',this.http.post<IPrikbordItemDb[]>(url,{}));
  }

  getPrikbordItemContent(prikbordItemId:number) {
    const url  = this.appService.getUrl(`api/prikbord/getprikborditemcontent?prikborditemid=${prikbordItemId}`);
    return this.http.post<string>(url,{});
  }

  getPrikbordBijlageUrl(prikbordItemId:number) {
    return this.appService.getDocUrl(`Api/Prikbord/GetDocumentContent?prikbordItemId=${prikbordItemId}`);
  }

}
